import { Header } from '@hyphengroup/cms-components/components/Header';
import { TheWrapper } from '@hyphengroup/cms-components/components/TheWrapper';
import { ComponentHeading } from '$/(cms)/_modules/cmsService/types';

export const Heading: React.FC<ComponentHeading> = ({ contentText, level }) => {
  if (!contentText) return null;

  return (
    <TheWrapper type="simple">
      <Header level={level}>{contentText}</Header>
    </TheWrapper>
  );
};
